export type TSolvei8Products = 'Tracki8' | 'Plani8' | 'Maintaini8';

export type TSolvei8Platforms = 'Input App' | 'BA App' | 'OI App' | 'TV Dashboards' | 'MM Analytics' | 'Plan Analytics';

export type TREQUEST_NPS_GET_FORM = {
  user_name: string;
  subject_key: string;
  product: TSolvei8Products;
  platform: TSolvei8Platforms;
};

export type TNPS_ANSWER_TYPE = 'Emoji' | 'Text' | 'Number';

export type TNPS_EMOJI = 'very_bad' | 'bad' | 'okay' | 'good' | 'excellent';

export const NPS_EMOJI_OPTIONS: readonly TNPS_EMOJI[] = ['very_bad', 'bad', 'okay', 'good', 'excellent'];
export const NPS_DETRACTOR_EMOJIS: readonly TNPS_EMOJI[] = ['very_bad', 'bad', 'okay'];
export const NPS_PROMOTER_EMOJIS: readonly TNPS_EMOJI[] = ['good', 'excellent'];

export const NPS_NUMBER_OPTIONS: readonly number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export type TNPS_FEEDBACK_QUESTION = {
  question: string;
  order_no: number;
  answer_type: TNPS_ANSWER_TYPE;
  detractor_questions: string[];
  promoters_questions: string[];
};

export type TRESPONSE_NPS_GET_FORM = TREQUEST_NPS_GET_FORM & {
  display_feedback_form: boolean;
  feedback_form_id: string;
  feedback_questions: TNPS_FEEDBACK_QUESTION[];
  timer_value: number;
  timer_for_enabling_submit: number;
};

export type TNPS_USER_ACTION = 'Skip' | 'Submit' | 'Timeout';

export type TNPS_USER_RESPONSE = {
  question: TNPS_FEEDBACK_QUESTION['question'];
  answer_type: TNPS_FEEDBACK_QUESTION['answer_type'];
  answer: string;
  selected_options: string[];
};

export type TREQUEST_NPS_SUBMIT_FORM = {
  user_name: TREQUEST_NPS_GET_FORM['user_name'];
  feedback_activation_uuid: TRESPONSE_NPS_GET_FORM['feedback_form_id'];
  feedback_form_data: TNPS_USER_RESPONSE[];
  user_action: TNPS_USER_ACTION;
};

export type TRESPONSE_NPS_SUBMIT_FORM = {
  status: 'SUCCESS' | 'FAILURE';
  error: string | null;
};

export type TNPS_MODAL_DISMISS_DATA = {
  action: TREQUEST_NPS_SUBMIT_FORM['user_action'];
  data: TNPS_USER_RESPONSE[];
};
